import RequestForMovementItemsGridPluginSettings from './RequestForMovementItems/RequestForMovementItemsGridPluginSettings'
import RequestForMovementPartyGridPluginSettings from './RequestForMovementItems/RequestForMovementPartyGridPluginSettings';
let index: number = 0;

const RequestForMovementGridPluginSettings: IPluginSettings = {
    name: "Заявка на перемещение",
    mnemocode: "request_for_movement_plugin",
    permission: "RequestForMovement",
    columns: [
        {
            order: index++,
            propertyName: "documentState",
            propertyType: "string",
            displayName: "Статус документа",
            visibility: true,
            width: 100,
        },
        {
            order: index++,
            propertyName: "idGlobal",
            propertyType: "string",
            displayName: "ИД",
            visibility: false,
            width: 200,
        },
        {
            order: index++,
            propertyName: "contractorName",
            propertyType: "string",
            displayName: "Получатель",
            visibility: true,
            width: 200,
        },
        {
            order: index++,
            propertyName: "storeName",
            propertyType: "string",
            displayName: "Склад получателя",
            visibility: true,
            width: 200,
        },
        {
            order: index++,
            propertyName: "supplierName",
            propertyType: "string",
            displayName: "Отправитель",
            visibility: true,
            width: 200,
        },
        {
            order: index++,
            propertyName: "supplierStoreName",
            propertyType: "string",
            displayName: "Склад отправителя",
            visibility: true,
            width: 200,
        },
        {
            order: index++,
            propertyName: "mnemocode",
            propertyType: "string",
            displayName: "Номер",
            visibility: true,
            width: 150,
        },
        {
            order: index++,
            propertyName: "documentDate",
            propertyType: "date",
            displayName: "Дата документа",
            visibility: true,
            width: 120,
        },       
        {
            order: index++,
            propertyName: "dateCreated",
            propertyType: "datetime",
            displayName: "Дата создания",
            visibility: true,
            width: 120,
        },
        {
            order: index++,
            propertyName: "dateModified",
            propertyType: "datetime",
            displayName: "Дата изменения",
            visibility: true,
            width: 120,
        },
        {
            order: index++,
            propertyName: "dateDeleted",
            propertyType: "datetime",
            displayName: "Дата удаления",
            visibility: true,
            width: 120,
        },       
    ],
    detailsPlugins: [RequestForMovementItemsGridPluginSettings, RequestForMovementPartyGridPluginSettings],
};
export default RequestForMovementGridPluginSettings;
